export default __webpack_public_path__ + "static/media/hobbies-banner.b9e1aadd.png";